import * as React from 'react';
import {
  ISelectedRepetitionChange,
  SelectedRepetitionChangeStream,
  SelectedRepetitionType,
} from '../../data/change_streams/selected_repetition/selected_repetition_change_stream';
import { repetitionsProvider } from '../../data/providers/repetitionsProvider';
import { ITestRepetition } from '../../data/types';

/**
 * @description
 * @returns
 */
export const useRepetitions = (
  testId: string
): {
  repetitions: ITestRepetition[];
  selectedRepetition: ITestRepetition | null;
  selectedRepetitionChangeStream: SelectedRepetitionChangeStream | null;
  loading: boolean;
} => {
  const [repetitions, setRepetitions] = React.useState<ITestRepetition[]>([]);
  const [selectedRepetition, setSelectedRepetition] =
    React.useState<ITestRepetition | null>(null);
  const [loading, setLoading] = React.useState<boolean>(true);

  React.useEffect((): (() => void) => {
    setLoading(true);

    const subscription = repetitionsProvider(testId).subscribe(
      (mData: ITestRepetition[]): void => {
        setRepetitions(mData);
        setLoading(false);
      }
    );

    return (): void => {
      subscription.unsubscribe();
    };
  }, [testId]);

  const selectedRepetitionChangeStream =
    React.useMemo((): SelectedRepetitionChangeStream => {
      return new SelectedRepetitionChangeStream(repetitions);
    }, [JSON.stringify(repetitions), testId]);

  React.useEffect((): (() => void) => {
    const subscriber = selectedRepetitionChangeStream.stream.subscribe(
      (change: ISelectedRepetitionChange): void => {
        if (change.type === SelectedRepetitionType.average) {
          setSelectedRepetition(null);
        } else if (change.type === SelectedRepetitionType.single) {
          const rep =
            selectedRepetitionChangeStream?.repetitions?.[change.payload - 1];
          setSelectedRepetition(rep);
        }
      }
    );
    return (): void => subscriber.unsubscribe();
  }, [JSON.stringify(selectedRepetitionChangeStream?.repetitions)]);

  return {
    repetitions,
    selectedRepetition,
    selectedRepetitionChangeStream,
    loading,
  };
};
